
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import CustomModal from '@/components/modal/CustomModal.vue';
import SignupForm from '@/components/signup/SignupForm.vue';
import { ApiError } from '@/model/ApiError';
import { SignupFormData } from '@/model/Signup';

@Component({ components: { CustomModal, SignupForm } })
export default class AddUserModal extends Vue {
    @Prop({ default: false, type: Boolean }) loading!: boolean;

    @Prop({ default: null }) error!: ApiError | null;

    close(): void {
        this.$bvModal.hide('add-user-modal');
    }

    @Emit('submit')
    onSubmit(formData: SignupFormData): SignupFormData {
        return formData;
    }

    @Emit('on-hidden')
    onHidden(): void {
        // Notify the container so it can clear the store error.
    }
}
